export default "<p>hkcli works!</p>\n"